const days = {
    0: "Domingo",
    1: "Lunes",
    2: "Martes",
    3: "Miércoles",
    4: "Jueves",
    5: "Viernes",
    6: "Sábado",
};

const calendarTemplates = {
    monthGridHeaderExceed(hiddenEvents) {
        return `<span>${hiddenEvents} más</span>`;
    },
    monthMoreTitleDate: (moreTitle) => {
        return `<span class="toastui-calendar-more-title-date">${moreTitle.date}</span>
        <span class="toastui-calendar-more-title-day ps-2">${days[moreTitle.day]}</span>`;
    },

    time: (schedule) => {
        return `
                <div style="color: ${schedule.color}; background-color: ${schedule.backgroundColor};">
                    ${schedule.raw}
                    ${schedule.title}
                </div>
                `;
    },
};

export default calendarTemplates;
